import React, { useEffect, useState, useRef } from 'react';
import { Form, Input, Upload, Button, message, Select, Modal } from 'antd'; // Adicionei message para feedback
import { CloudUploadOutlined } from '@ant-design/icons';
import axios from 'axios';
import styles from '../../assets/css/formulario.module.css';
import PoliticaPrivacidade from '../Politica';
import ReactInputMask from 'react-input-mask';
import { toast } from 'react-toastify';

const EBOOK_PDF_URL = 'https://lp.meucontadoronline.com.br/whatsapp-mco/landing/ebook/download';
const EBOOK_FILE_NAME = 'ebook.pdf';


const Formulario = ({ selectedOption, selectOption, setSelectOption, handleClose }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        form.setFieldValue('categoria', selectOption || undefined);
    }, [selectOption]);

    const login = async () => {
        try {
            // 1. Alterado para .get e adicionado o prefixo /security configurado no @RequestMapping
            const response = await axios.post("https://lp.meucontadoronline.com.br/security/loginPortal", {});
            sessionStorage.setItem("JSESSIONID", response.data.JSESSIONID);

        } catch (error) {
            console.error("Erro ao fazer login:", error);
            // É bom relançar o erro ou tratar caso outras funções dependam desse retorno
            throw error;
        }
    };

    const utmServer = async () => {
        const baseUrl = "https://lp.meucontadoronline.com.br/whatsapp-mco/security/bff/security/utm";

        const searchParams = new URLSearchParams(window.location.search);

        //console.log("Enviando dados para UTM Server:", searchParams.toString());

        try {

            //const jsessionid = sessionStorage.getItem("JSESSIONID");

            if (searchParams.get("utm_source") === null) {
                return; // Se a URL não estiver configurada, saia da função
            }

            const response = await axios.post(baseUrl, {
                date: new Date().toISOString().slice(0, 19),
                url: window.location.href,
                utmId: searchParams.get("utmId") || "1",
                utmSource: searchParams.get("utm_source") || "",
                utmMedium: searchParams.get("utm_medium") || "",
                utmCampaign: searchParams.get("utm_campaign") || "",
                utmTerm: searchParams.get("utm_term") || "",
                utmContent: searchParams.get("utm_content") || "",
                gclid: searchParams.get("gclid") || "",

                osId: searchParams.get("osId") || localStorage.getItem("osId") || "0",
                //clienteId: searchParams.get("clienteId") || localStorage.getItem("clienteId") || "0"
            });

            return response.data;

        } catch (error) {

            console.error("Erro ao enviar UTM:", error);
            throw error;
        }
    };

    const baixarEbook = async () => {
        const toastId = toast.loading('Estamos preparando o seu e-book, aguarde...');

        try {
            const response = await axios.get(EBOOK_PDF_URL, {
                responseType: 'blob',
            });

            const blobUrl = window.URL.createObjectURL(
                new Blob([response.data], { type: 'application/pdf' })
            );

            const link = document.createElement('a');
            link.href = blobUrl;
            link.setAttribute('download', EBOOK_FILE_NAME);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(blobUrl);

            toast.update(toastId, {
                render: 'Seu e-book foi baixado com sucesso!',
                type: 'success',
                isLoading: false,
                autoClose: 4000,
            });
        } catch (error) {
            console.error('Erro ao baixar o e-book:', error);
            toast.update(toastId, {
                render: 'Não conseguimos baixar o e-book automaticamente. Tente novamente em alguns instantes.',
                type: 'error',
                isLoading: false,
                autoClose: 5000,
            });
        }
    };


    // Função para formatar o payload conforme sua estrutura
    const formatPayload = (values) => {
        const now = new Date().toISOString();

        const cpfLimpo = values.cpf ? values.cpf.replace(/\D/g, '') : "";
        const telefoneLimpo = values.telefone ? values.telefone.replace(/\D/g, '') : "";


        return {
            id: "",
            contato: {
                nome: values.nome,
                cpf: cpfLimpo,
                email: values.email,
                telefone: telefoneLimpo
            },
            /*tipo: {
                id: selectOption === '1' ? "1"
                 : selectOption === '2' ? "2" 
                 : selectOption === '3' ? "3" 
                 : "" 
                 || selectedOption === "abrir" ? "1" : selectedOption === "trocar" : "2" : selectedOption === "migrar" ? "3" : ""
            },*/

            tipo: {
                id: "2"
            },
            dataCriacao: now,
            situacao: {
                id: "I"
            },
            dataSituacao: now
        };
    };

    const handleProcessarEnvio = async () => {
        try {
            setLoading(true);

            const values = await form.validateFields();
            const payload = formatPayload(values);

            // 1. Login
            //await login();

            // 1. Chamada de Verificação
            const resVerificar = await axios.post(
                'https://portal.meucontadoronline.com.br/merp/rest/ordem-servico/vendas/verificar',
                payload
            );

            // Ajuste a verificação conforme o retorno real da sua API
            if (resVerificar.status === 204 || resVerificar.status === 200) {

                // 2. Chamada de Cadastro
                const resCadastrar = await axios.post(
                    'https://portal.meucontadoronline.com.br/merp/rest/ordem-servico/vendas/cadastrar',
                    payload
                );

                if (resCadastrar.status === 200) {
                    
                    // 3. Preparar dados para a API local
                    const servicosMap = {
                        abrir: "abrir uma empresa",
                        trocar: "trocar de contabilidade",
                        migrar: "Migrar de MEI para ME"
                    };

                    console.log("Dados para API local:", resCadastrar);

                    localStorage.setItem("osId", resCadastrar.data.id);
                    localStorage.setItem("clienteId", resCadastrar.data.contato.id);

                    const param = {
                        telefone: payload.contato.telefone,
                        nome: payload.contato.nome,
                       
                        //servico: selectOption || ""
                    };

                    // 5. UTM Server (último)
                    await utmServer();

                    //message.success('Recebemos suas informações.Entramos em contato via WhatsApp!');

            
                    // 4. Chamada para a API Local
                    const response = await axios.post(`https://lp.meucontadoronline.com.br/whatsapp-mco/landing/ebook/chamar`, param);

                    if (response.status === 200 || response.status === 204) {

                        form.resetFields(); // Limpa apenas após todo o sucesso
                        handleClose?.(); // Fecha o modal após o envio bem-sucedido

                        


                        /*Modal.success({
                            title: null,
                            centered: true,
                            okText: '[ fechar ]',
                            icon: null,
                            styles: {
                                content: {
                                    background: 'transparent',
                                    boxShadow: 'none',
                                    padding: 0,
                                    width: '100%',
                                },
                                mask: {
                                    backdropFilter: 'blur(4px)',
                                },
                            },
                            content: (
                                <div style={{
                                    background: '#0d1117',
                                    borderRadius: 10,
                                    padding: '24px 16px',
                                    fontFamily: '"Fira Code", "Courier New", monospace',
                                }}>
                                   




                                    <div style={{
                                        borderTop: '1px solid #21262d',
                                        paddingTop: 14,
                                        color: '#e6edf3',
                                        fontSize: 16,
                                        lineHeight: 1.6,
                                    }}>
                                        <span style={{ color: '#57606a' }}>// </span>
                                        Recebemos suas informações.<br />
                                        <span style={{ color: '#57606a' }}>// </span>
                                        Entraremos em contato via{' '}
                                        <span style={{ color: '#aff5b4' }}>WhatsApp</span> em breve.
                                    </div>
                                </div>
                            ),
                            centered: true,
                            okText: '[ fechar ]',
                            icon: null,
                            okButtonProps: {
                                style: {
                                    background: 'transparent',
                                    border: '1px solid #aff5b4',
                                    color: '#aff5b4',
                                    fontFamily: '"Fira Code", monospace',
                                    borderRadius: 6,
                                }
                            },
                            modalRender: (node) => (
                                <div style={{ background: '#0d1117', borderRadius: 12, overflow: 'hidden', border: '1px solid #21262d' }}>
                                    {node}
                                </div>
                            ),
                        });*/

                        baixarEbook();



                        if (response.status === 200 || response.status === 204) {
                            //message.success('Solicitação enviada com sucesso!');
                            form.resetFields(); // Limpa apenas após todo o sucesso

                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                event: 'formEbookEnviado',
                                formId: 'form-lp-ebook',
                                servico: servicosMap[selectedOption?.id] || "",
                                timestamp: new Date().toISOString()
                            });

                            console.log('Evento enviado para o dataLayer:', {
                                event: 'formEbookEnviado',
                                formId: 'form-lp-ebook',
                                servico: servicosMap[selectedOption?.id] || "",
                                timestamp: new Date().toISOString()
                            });
                        }
                    }


                


                }
            } else {
                message.warning('Não foi possível prosseguir com a verificação.');
            }
        } catch (error) {
            console.error("Erro na operação:", error);
            const msg = error.response?.data?.mensagem || 'Ocorreu um erro ao processar a solicitação.';
            message.error(msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>


            <div style={{
                color: "#0e0e0e",
                marginBottom: 30,
                marginTop: 20,
                textAlign: "center",
                fontSize: "clamp(18px, 5vw, 18px)" // Fonte fluida: diminui no mobile
            }}>
                <label>
                    {selectOption === "1" && <>Inicie a <strong style={{ color: "#0056b3" }}>Abertura da sua Empresa</strong> de forma simples e rápida</>}
                    {selectOption === "2" && <>Inicie a <strong style={{ color: "#0056b3" }}>Troca da sua Contabilidade</strong> de forma simples e rápida</>}
                    {selectOption === "3" && <>Inicie a <strong style={{ color: "#0056b3" }}>Migração de MEI para ME</strong> de forma simples e rápida</>}
                    {!selectOption && <>Inicie a <strong style={{ color: "#0056b3" }}>sua jornada</strong> de forma simples e rápida</>}
                </label>

                <p style={{ color: "#ffffff", marginTop: 10 }}>
                    Preencha o formulário, um de nossos especialistas entrará em contato.
                </p>
            </div>

            <Form form={form} layout="vertical" id='form-lp-ebook'>
                <div className={styles['billing-section']}>
                    <div>
                        {/**<span className={styles['section-label']}>Categoria</span>
                        <Form.Item name="categoria" rules={[{ required: true, message: 'Campo obrigatório' }]}>
                            <Select
                                placeholder="Selecione o serviço desejado"
                                onChange={(value) => setSelectOption(value)}
                            >
                                <Select.Option value="1">Abrir Empresa</Select.Option>
                                <Select.Option value="2">Trocar de Contabilidade</Select.Option>
                                <Select.Option value="3">Migrar MEI para ME</Select.Option>
                            </Select>
                        </Form.Item> */}

                        <span className={styles['section-label']}>Nome Completo</span>
                       {/** <Form.Item name="nome" rules={[{ required: true, message: 'Campo obrigatório' }]}>
                            <Input placeholder="Nome Completo" />
                        </Form.Item> */}


                        <Form.Item 
                            name="nome" 
                            rules={[
                                { required: true, message: 'Campo obrigatório' },
                                {
                                    validator: (_, value) => {
                                        if (!value) {
                                            return Promise.resolve();
                                        }
                                        // Remove espaços extras no início/fim e divide por espaços
                                        const partesNome = value.trim().split(/\s+/);
                                        // Valida se existem pelo menos duas partes (nome e sobrenome) e se a segunda não está vazia
                                        if (partesNome.length < 2 || partesNome[1].length < 1) {
                                            return Promise.reject(new Error('Por favor, digite seu nome e pelo menos um sobrenome.'));
                                        }
                                        return Promise.resolve();
                                    }
                                }
                            ]}
                        >
                            <Input placeholder="Nome Completo" />
                        </Form.Item>

                        <span className={styles['section-label']}>CPF</span>
                        <Form.Item name="cpf" rules={[{ required: true, message: 'Campo obrigatório' }]}>


                            <ReactInputMask mask="999.999.999-99" maskChar={null}>
                                {(inputProps) => <Input {...inputProps} placeholder="XXX.XXX.XXX-XX" />}
                            </ReactInputMask>
                        </Form.Item>
                    </div>

                    <div>
                        <span className={styles['section-label']}>Email</span>
                        <Form.Item name="email" rules={[{ required: true, type: 'email', message: 'Email inválido' }]}>
                            <Input placeholder="Email" />
                        </Form.Item>

                        <span className={styles['section-label']}>Telefone</span>
                        <Form.Item name="telefone" rules={[{ required: true, message: 'Campo obrigatório' }]}>
                            <ReactInputMask mask="(99) 99999-9999" maskChar={null}>
                                {(inputProps) => <Input {...inputProps} placeholder="(00) 00000-0000" />}
                            </ReactInputMask>
                        </Form.Item>
                    </div>
                </div>

                <div>
                    <p style={{ color: "#4f4f4f" }}>
                        Não se preocupe, seus dados não serão utilizados para outra finalidade. Conheça nossa {' '}
                        <span onClick={() => setOpen(true)} style={{ color: "#3154f1", cursor: "pointer" }}>
                            Política de privacidade.
                        </span>
                    </p>
                </div>

                <div style={{ textAlign: 'center', marginTop: 20 }}>
                    <Button
                        id='btn-lp-dev'
                        type="primary"
                        onClick={handleProcessarEnvio}
                        loading={loading}
                        block
                        style={{
                            maxWidth: 300,
                            height: 35,
                            borderRadius: 8,
                            fontSize: 14,
                            fontWeight: 600
                        }}
                    >
                        Enviar Solicitação
                    </Button>
                </div>

            </Form>


            {open && (
                <PoliticaPrivacidade open={open} setOpen={setOpen} />
            )}
        </>
    );
};

export default Formulario;